import { withStyles } from "@material-ui/styles";
import default_user from "Images/default_user.png";
import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import styles, { ProfileContainer } from "./styles";
import AppConfig from "Config/AppConfig";

class ProfileImage extends Component {
  state = {
    error: false,
  };

  handleClick = (e) => {
    this.props.onClick(e);
  };

  addDefaultSrc = (e) => {
    e.target.src = default_user;
    e.target.onerror = null;
  };

  render() {
    const { userDetails } = this.props;
    const { error } = this.state;

    const DefaultPic = AppConfig.NoProfilePic;

    if (error || !userDetails.avatar)
      return (
        <ProfileContainer onClick={this.handleClick}>
          <DefaultPic size={30} />
        </ProfileContainer>
      );

    return (
      <ProfileContainer
        onClick={this.handleClick}
        image={userDetails.avatar}
        onError={() => this.setState({ error: true })}
      />
    );
  }
}

const NavbarItem = (_props) => {
  const { classes, children } = _props;
  return <div className={classes.dropdownItem}>{children}</div>;
};

const NavbarDropdown = (props) => {
  const { classes, children, profile, userDetails } = props;
  return (
    <Dropdown>
      <Dropdown.Toggle
        as={ProfileImage}
        id="dropdown-custom-components"
        classes={classes}
        profile={profile}
        userDetails={userDetails}
      />
      <Dropdown.Menu alignRight>
        {children.map((item, key) => {
          return (
            <NavbarItem key={key} classes={classes}>
              {item}
            </NavbarItem>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default withStyles(styles)(NavbarDropdown);
